import React, { ChangeEvent, FormEvent, useCallback, useEffect, useMemo, useState } from 'react'
import Template from '../components/Template'

import { useSelector } from 'react-redux';
import Select, { components } from 'react-select'
import axios from 'axios'
import { CURRENCY, ServerUrl, config, staffCode, styles } from '../components/Includes'
import { usePaginated, DOTS } from '../components/usePagination';
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2'
import { ImagesUrl } from '../components/Includes';
import { CustomLoader, ErrorModal, LoadingModal, SuccessModal, closeModal } from '../components/notify';
import { FormatNumber } from '../components/GlobalFunction'

const CardRequest =()=> {


  const group  = useSelector((state:any) => state.rootReducer.group);
    const [loading, setLoading] = useState(false);
    const [filterContent, setFilterContent] = useState([] as any);
    const [content, setContent] = useState([] as any);
 
    const [location, setLocation] = useState([]as any)
 
    const [search, setSearch]= useState({
      clientname:'',
      payment_status:'',
      card_no:'',
      location:'' as any,
      card_status:'',
      serial_no:'',
      filterText:'',
      date_created:'',
        selectAll:false,
        totalSelected:0,
        group:[] as any,
       

    })
   
  
    const fetchLocation = async()=>{
      let url = ServerUrl+'/location/display/all'
        await  axios.get(url,  config).then((result:any)=>{
          
          if(result.data.data&&result.data.data.length!==0){
            setLocation(result.data.data)
          }
          })
        }


    const handleClear =()=>{
      setSearch({...search, filterText:''});
      setFilterContent(content)
  }


    const handleSearch =(event:ChangeEvent<HTMLInputElement>)=>{
      let {name, value} = event.target;	
      setSearch({...search, [name]:value});

      if(value!==''){
          const filteredItems = content.filter(
              (item:any) => item.fullname.toLowerCase().includes(value.toLowerCase()) || 
              item.serial_no.includes(value.toLowerCase()) || 
              item.address.toLowerCase().includes(value.toLowerCase())|| 
              item.card_status.toLowerCase().includes(value.toLowerCase())|| 
              item.payment_status.toLowerCase().includes(value.toLowerCase())
          );

          setFilterContent(filteredItems)
      }else{
          setFilterContent(content)
      } 

   }





const handleChange =(event:ChangeEvent<HTMLInputElement>)=>{
  let {name, value} = event.target;	
  setSearch({...search, [name]:value});
}

const handleChangeSelect =(event:ChangeEvent<HTMLSelectElement>)=>{
  let {name, value} = event.target;	
  setSearch({...search, [name]:value});
}


const handleSelect = (option:any, action:any)=>{
setSearch({...search, [action.name]:option.value});
   }

    const fetchContent = async()=>{
  LoadingModal()

  let url = ServerUrl+'/card/display/all'
  await  axios.get(url, config).then((result:any)=>{
 
           if(Array.isArray(result.data.data) && result.data.data.length!==0){
          
               setFilterContent(result.data.data)
             setContent(result.data.data)
             }
           })
           .catch((error)=>{
               
        ErrorModal('oops', error.message)
           }).finally(()=>{
               closeModal()
           })
           } 


 
    

         const TableData =()=>{

            const PaginationWrapper =(props:any)=>{
            
                const handleRowsPerPage = useCallback(
                    (e: React.ChangeEvent<HTMLSelectElement>) => props.onChangeRowsPerPage(Number(e.target.value), props.currentPage),
                    [props.currentPage, props.onChangeRowsPerPage],
                );
                const handleSelectRowsPerPage = useCallback((option:any, action:any)=> props.onChangeRowsPerPage(Number(option.value), props.currentPage),
                [props.currentPage, props.onChangeRowsPerPage],
                )
               
                function getNumberOfPages(rowCount:number, rowsPerPage:number) {
                    return Math.ceil(rowCount / rowsPerPage);
                  }
                const numPages = getNumberOfPages(props.rowCount, props.rowsPerPage);
                const lastIndex = props.currentPage * props.rowsPerPage;
                const firstIndex = lastIndex - props.rowsPerPage + 1;
            
            
                    const range =
                    props.currentPage === numPages ?  `Showing ${firstIndex} to ${props.rowCount} of ${props.rowCount} entries`:
            
                    `Showing ${firstIndex} to ${lastIndex} of ${props.rowCount} entries`
            
                
               
                const Pagination = () => {
                   
                    const pageSize = props.rowsPerPage;
                    const totalCount = content.length
                    const siblingCount = 1
                    const currentPage = props.currentPage
                    
                    const paginationRange = usePaginated({ currentPage,  totalCount, siblingCount,  pageSize });
                    
                    if (currentPage === 0 ) {
                      return null;
                    }
                    
                    let lastPage =  paginationRange&&paginationRange[paginationRange.length - 1];
                    return (
                    <nav className="" aria-label="Page navigation sample ">
                      <ul  className="pagination pagination-sm"  >
                        <li className={currentPage === 1 ? ' page-item disabled' : 'page-item'} >
                         <a className="page-link pointer"  onClick={() =>props.onChangePage(props.currentPage - 1)}>Previous</a>
                        </li>
                        {paginationRange&&paginationRange.map((pageNumber, index) => {
                          if (pageNumber === DOTS) {
                            return <li className="pagination-item dots" key={index}>
                             <a className="page-link pointer"  >&#8230;</a>
                            </li>
                          }
                          return (
                            <li className={pageNumber === currentPage?' page-item  active':'page-item '} key={index} >
                              <a className="page-link pointer"  onClick={() =>props.onChangePage(pageNumber)} >{pageNumber}</a>
                              
                            </li>
                          );
                        })}
                    
                    <li  className={currentPage === lastPage  ? ' page-item disabled' : 'page-item'}>
                    <a className="page-link pointer"  onClick={() =>props.onChangePage(props.currentPage + 1)} aria-label="Next">Next</a>
                        </li>
                    
                      </ul> </nav>
                    );
                    
                        }
            
                      
            
                      
            
             return <div className="row mt-3">
                                
            <div className="col-md-5 ">
            
            
               Rows per page: &nbsp; <select name="rowPerPage" id="" className='w-40-h-30 ' onChange={handleRowsPerPage}>
                    <option value="10"> 10</option>
                    <option value="20"> 20</option>
                    <option value="30"> 30</option>
                    <option value="40"> 40</option>
                    <option value="50"> 50</option>
                    <option value={content.length}> All</option>
                </select> &nbsp;&nbsp;
                 {range}  </div>
            
              
            <div className="col-md-7  justify-content-end d-flex">
               <Pagination  />
                </div>
                
            </div>}
            
            
            
                        const columns = [
                          {
                            name: 'Serial No',
                            cell: (row:any, index:number) => row.serial_no, 
                            sortable: true,
                            reorder:true,
          
                        },
                            {
                              name: 'Client',
                              cell: (row:any) => row.fullname, 
                              sortable: true,
                              reorder:true,
                              wrap:true,
            
                          },
                          {
                            name: 'Address',
                            cell: (row:any) => row.address, 
                            sortable: true,
                            reorder:true,
                            wrap:true,
          
                        },
                        {
                          name: 'Card Price',
                          cell: (row:any) => FormatNumber(row.card_price), 
                          sortable: true,
                          reorder:true,
                          wrap:true,
        
                      },
                          {
                            name: 'Delivery',
                            cell: (row:any) => FormatNumber(row.location_price), 
                            sortable: true,
                            reorder:true,
                            wrap:true,
          
                        },
                        {
                          name: 'Total',
                          cell: (row:any) => FormatNumber(row.total), 
                          sortable: true,
                          reorder:true,
                          wrap:true,
        
                      },
                      {
                        name: 'Status',
                        cell: (row:any) =>  <span className={`badge rounded-pill ${row.payment_status==='Pending'?'bg-danger':row.payment_status==='Paid'?'bg-success':'bg-primary'}`} >{row.payment_status}</span>, 
                        sortable: true,
                        reorder:true,
                        wrap:true,
      
                    },
                      {
                        name: 'Date Apply',
                        cell: (row:any) => new Date(row.created_at).toISOString().slice(0,19), 
                        sortable: true,
                        reorder:true,
                        wrap:true,
                        
      
                    },
                    {
                      name: 'Card Status',
                      cell: (row:any) => <span className={`badge rounded-pill ${row.card_status==='Pending'?'bg-danger':row.card_status==='Processing'?'bg-primary':'bg-success'}`} >{row.card_status}</span>,
                      sortable: true,
                      reorder:true,
                      wrap:true,
    
                  },
                  {
                    name: 'Action',
                   cell: (row:any, index:any, column:any, id:any) => <div className='col'>  
                      
                      {group.includes('rl8')? <a href={'/client/card/view/'+row.code} className="btn btn-info btn-sm "   ><i className='bi bi-eye'></i> View </a>:[]}&nbsp;


                   </div>,
                       left:true,
                       
                             
   
               },
                        ];
                        
                    
                    
                    
                        return <>
                        
            
                        <DataTable
                        columns={columns}
                        data={filterContent}
                        highlightOnHover
                        pagination
                        paginationComponent={PaginationWrapper}
                        selectableRowsHighlight
                        striped
                        responsive
                        fixedHeader
                        progressPending={loading}
                        progressComponent={<CustomLoader />}
                    />
                    </>
                    }



            useEffect(()=>{
              fetchContent()
              fetchLocation()
            }, [])

  return (<Template> 

<main id="main" className="main">
<div className="pagetitle">
  <h1>Card Request</h1>
  <nav >
    <ol className="breadcrumb">
      <li className="breadcrumb-item"><a href="/dashboard">Home</a></li>
      <li className="breadcrumb-item active"> Card</li>
    </ol>
  </nav>
</div>




<section className="section">
 <div className="row">
<div className="col-lg-12">

				<div className="card ">
                                    
        <h5 className="card-header">Search Card</h5>

<div className="card-body"> 
<div className="row">
                <div className="col-lg-6 col-md-6 col-sm-6">
                    <div className="form-group row mb-3 mt-3">

                    <label className="col-sm-4 col-form-label">Client Name</label>
                                    
                    <div className="col-lg-8 col-md-8 col-sm-8">
                        <input type="text" className="form-control" onChange={handleChange} name="clientname" value={search.clientname} />
                        </div>
                    </div>




                    <div className="form-group row mb-3">
                      <label className="col-sm-4 col-form-label">Payment Status</label>
                                    
                    <div className="col-lg-8 col-md-8 col-sm-8">

                    <Select  options={[
                    { value: 'Pending', label: 'Pending' },
                    { value: 'Paid', label: 'Paid'},
                                ]} 
                       
                                onChange={handleSelect}  name="payment_status"
                        value={{value:search.payment_status, label:search.payment_status}} 
                 />
                    
                        </div>
                    </div>


                    <div className="form-group row mb-3">
                      <label className="col-sm-4 col-form-label">Card Status</label>
                                    
                    <div className="col-lg-8 col-md-8 col-sm-8">

                    <Select  options={[
                    { value: 'Processing', label: 'Processing' },
                    { value: 'Pending', label: 'Pending'},
                    { value: 'Delivered', label: 'Delivered'},
                                ]} 
                       
                                onChange={handleSelect}  name="card_status"
                        value={{value:search.card_status, label:search.card_status}} 
                 />
                    
                        </div>
                    </div>

                </div>

                <div className="col-lg-6 col-md-6 col-sm-6">
                <div className="form-group row mb-3 mt-3">
                <label className="col-sm-4 col-form-label">Location</label>
                                    
                <div className="col-lg-8 col-md-8 col-sm-8">
                <Select  
                  
                  options={
                    location&&location.map((list:any, id:number)=>{
                         return {key:id, value:list.code, label:list.title, price:list.price}
                             })}
                    
styles={styles}
onChange={handleSelect}  name="locations" value={search.location} 
/>

    </div>
                    </div>
                   
                    <div className="form-group row mb-3 mt-3">
                <label className="col-sm-4 col-form-label">Date Created</label>
                                    
                    <div className="col-lg-8 col-md-8 col-sm-8">
                        <input type="date" className="form-control" onChange={handleChange}  name="date_created" value={search.date_created} />
                        </div>
                    </div>



                    <div className="form-group row mb-3">
                    <label className="col-sm-4 col-form-label">Serial No</label>
                                    
                    <div className="col-lg-8 col-md-8 col-sm-8">
                        <input type="text" className="form-control" onChange={handleChange}  name="serial_no" value={search.serial_no} />
                        </div>
                    </div>
                </div>
                </div>
            


            <div className="row mt-3"> 
            
            <div className="col-lg-7 d-flex justify-content-end">
           

            <button type="button" className="btn btn-secondary  "   ><i className="bi bi-arrow-clockwise"></i> Clear</button>&nbsp;
	<button type="button" className="btn btn-primary " onClick={fetchContent}  ><i className="bi bi-search"></i> Search</button>
   


    </div>
            
            </div>
            </div>
            </div>
            
            </div>

         
          
            </div>
            </section>









            <section className="section">
 <div className="row">
<div className="col-lg-12">

				<div className="card ">
                                    
        <h5 className="card-header">All Card</h5>

<div className="card-body"> 



<div className="row mt-3 mb-3">


    <div className=" col-md-4 ">
    <div className="input-group  " >
                    <input type="text" name="filterText" id="filterText" key="filterText"  onChange={handleSearch} value={search.filterText} className="form-control float-right form-control" placeholder="Type to search" />
                   
                    <div className="input-group-append">
                        <button type="button" onClick={handleClear} className="btn btn-secondary " >
                          <i className="bi bi-arrow-repeat"></i>
                        </button>
                      </div>
                  </div>
      

    </div>
</div>


<TableData />
            
            </div>
            </div>
            
            </div>

         
          
            </div>
            </section>
                            </main>
    </Template>
  )
}

export default CardRequest